import moment from 'moment-timezone';
import { formatNumber } from '../../../common/money';

export const format = timezone => (item) => {
  const row = {
    'Original Borrowed Total': formatNumber(item.loanAmountBorrowed),
    'Original Borrowed Date': moment.tz(item.loanRepaymentStartDate, timezone).format('L'),
    'Repayment % Rate': `%${item.loanRepaymentPercentage}`,
    'Amount Owed': formatNumber(item.loanAmountOwed),
  };

  if (item.loanAmountOwed !== 0) {
    if (item.loanRepaymentPercentage !== 0) {
      row['Expected Repayment Date'] = moment.tz(item.expectedRepaymentEndDate, timezone).format('L');
      row['Repayment Status'] = 'Ongoing';
    } else {
      row['Repayment Status'] = 'Suspended';
    }
  } else {
    row['Repayment Status'] = 'Complete';
  }
  return row;
};

const makeReport = (report, timezone) => {
  const withTimezone = format(timezone);
  return withTimezone(report);
};

export default makeReport;
